// extracted by mini-css-extract-plugin
export default {"thumb":"grid-icon-item-module__thumb--TC8OE"};